"use client";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

export default ReactQueryDevtools;
